import { QuoteDetails } from '@domgen/dgx-fe-basket';
import { RegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.interface';

export interface ProtectionAdditionalQuoteModalData {
  additionalQuotes: QuoteDetails[];
  applianceDetails: RegistrationApplianceDetails;
  quoteDetails?: QuoteDetails;
}
